import { prefixObjectValues } from '../utils';

const employerAssociation = {
  section: 'section',
  employerName: 'employer-name',
  status: 'status',
  disassociateBtn: 'disassociate-btn',
  associatedDate: 'associated-date',
  noAssociation: 'no-association',
  historySection: 'history-section',
  historyRow: 'history-row',
  historyEmployerName: 'history-employer-name',
  historyAssociatedDate: 'history-associated-date',
  historyEndedDate: 'history-ended-date',
  historyEndReason: 'history-end-reason',
  historyEmpty: 'history-empty',
  historyStale: 'history-stale',
  historyError: 'history-error',
};

const tabs = {
  accountTab: 'account-tab',
  employerAssociationTab: 'employer-association-tab',
};

export default {
  employerAssociation: prefixObjectValues(
    employerAssociation,
    'provider-settings-employer-association'
  ),
  tabs: prefixObjectValues(tabs, 'provider-settings'),
};
